import '../shared/types';

/**
 * @typedef {object} StatsLeadersState
 * @property {StatsLeadersNavState} nav
 * @property {StatsSortState} sort
 * @property {StatsLeadersFilterState} filters
 * @property {StatsBenchmarkingState} benchmarking
 * @property {StatsLeadersDataTypeState} dataType
 * @property {object} values
 * @property {object} values.stats
 * @property {object} values.players
 * @property {object} values.teams
 * @property {object} keys
 * @property {object} keys.seasons
 * @property {object} keys.rounds
 * @property {StatsLeadersRequestDetails[]} requests
 */

/**
 * @typedef {object} StatsLeadersNavState
 * @property {number} playerCount
 * @property {string} category
 * @property {object} competition
 * @property {number|null} competition.id
 * @property {object} season
 * @property {number|null} season.id
 * @property {object} round
 * @property {number|null} round.id
 * @property {number|null} round.number
 */

/**
 * @typedef {object} StatsLeadersFilterState
 * @property {string[]} positions
 * @property {string[]} teams
 */

/**
 * @typedef {object} StatsLeadersDataTypeState
 * @property {'totals'|'averages'|'benchmarkedTotals'|'benchmarkedAverages'} type
 */

/**
 * @typedef {object} StatsLeadersRequestDetails
 * @property {string} id
 * @property {'rounds'|'seasons'} type
 * @property {boolean} benchmarking
 */